// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Theme Switcher Css */
:host {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 var(--ids-space-3xs);
}

:host([hidden]) {
  display: none;
}

#ids-theme-switcher {
  z-index: var(--ids-z-index-0);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-theme-switcher/ids-theme-switcher.scss"],"names":[],"mappings":"AAAA,2BAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,6BAAA;AAAF","sourcesContent":["/* Ids Theme Switcher Css */\n\n:host {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding: 0 var(--ids-space-3xs);\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n#ids-theme-switcher {\n  z-index: var(--ids-z-index-0);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
